import { GatsbyImage } from 'gatsby-plugin-image';

const ImageBlock = ({ image }) => (
  <figure className="mb-10 mx-auto">
    <div className="aspect-[21/9] overflow-hidden rounded-3xl">
      <GatsbyImage
        image={image.localFile.childImageSharp.gatsbyImageData}
        alt={`Imagen de Referencia de ${image.alternativeText}`}
        className="w-full h-full object-cover"
        placeholder="BLURRED"
      />
    </div>
    {image.alternativeText && (
      <figcaption className="mt-1 text-right text-xs text-slate-400">
        {`Ref. de ${image.alternativeText}`}
      </figcaption>
    )}
  </figure>
);

export default ImageBlock;
